// extracted by css-extract-rspack-plugin
export default {"TopDockMobile":"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__TopDockMobile-Q1yax7","topDockMobile":"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__TopDockMobile-Q1yax7","leftSection":"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__leftSection-buAGPZ","logo":"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__logo-K3HAvu","logoIcon":"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__logoIcon-BQlSMj"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"TopDockMobile\":\"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__TopDockMobile-Q1yax7\",\"topDockMobile\":\"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__TopDockMobile-Q1yax7\",\"leftSection\":\"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__leftSection-buAGPZ\",\"logo\":\"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__logo-K3HAvu\",\"logoIcon\":\"src-shared-components-MainLayout-components-TopDock-mobile-TopDockMobile-module__logoIcon-BQlSMj\"}";
        // 1793872692594
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  